<template>
  <div class="distributionMarket_box" :style="setCssVar">
    <!--商品筛选条件区域-->
    <div class="filter_box">
      <!--排序-->
      <div class="filter_box_item">
        <span>{{ $t('key1003034') }}</span>
        <div class="sort_content">
          <div class="sort_content_item" v-for="(ele, idx) in sortList" :key="idx" @click="sortBtn(idx)">
            <span class="sort_title" :class="ele.selected ? 'sort_active' : ''">{{ ele.name }}</span>
            <span class="sort_icon_box" v-if="ele.sort">
              <Icon class="dropup_icon" size="16" type="md-arrow-dropup"
                :color="ele.type === 'up' ? isAlibabaDistributor ? '#2D8CF0' : '#FD5425' : '#515A6E'" @click.stop="sortupDownBtn(idx,'up')"/>
              <Icon class="dropdown_icon" size="16" type="md-arrow-dropdown"
                :color="ele.type === 'down' ? isAlibabaDistributor ? '#2D8CF0' : '#FD5425' : '#515A6E'" @click.stop="sortupDownBtn(idx,'down')"/>
                </span>
            <span class="line_txt"></span>
          </div>
        </div>
      </div>
      <!--库存-->
      <div class="filter_box_item stock_styles">
        <Select class="stock_select" v-model="pageParams.inventoryType">
          <Option v-for="item in stockTypeList" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
        <div class="stock_input_box">
          <InputNumber class="stock_input" :placeholder="$t('key1005543')" :max="9999999999" :min="0"
            @on-focus="handleFocus(pageParams.minInventory)" @on-blur="handleBlur(pageParams.minInventory)"
            v-model="pageParams.minInventory" :formatter="(value) => parseInt(value)"></InputNumber>
          <span class="line_item">-</span>
          <InputNumber class="stock_input" :placeholder="$t('key1005544')" :max="9999999999" :min="0"
            @on-focus="handleFocus(pageParams.maxInventory)" @on-blur="handleBlur(pageParams.maxInventory)"
            v-model="pageParams.maxInventory" :formatter="(value) => parseInt(value)"></InputNumber>
        </div>
      </div>
      <!--价格-->
      <div class="filter_box_item">
        <span>{{ $t('key1005547') }}</span>
        <InputNumber class="price_input" :placeholder="$t('key1005545')" :max="9999999999" :min="0"
          @on-focus="handleFocus(pageParams.minPrice)" @on-blur="handleBlur(pageParams.minPrice)"
          v-model="pageParams.minPrice" :formatter="(value) => formatterNumber(value, 2)"></InputNumber>
        <span class="line_item">-</span>
        <InputNumber class="price_input" :placeholder="$t('key1005546')" :max="9999999999" :min="0"
          @on-focus="handleFocus(pageParams.maxPrice)" @on-blur="handleBlur(pageParams.maxPrice)"
          v-model="pageParams.maxPrice" :formatter="(value) => formatterNumber(value, 2)"></InputNumber>
      </div>
      <div class="flex align-items-center" v-if="handleShowDefine() && showDefine">
        <Button style="margin: 0 20px 16px 0;" @click="reset">{{ $t('key1000109') }}</Button>
        <Button type="primary" style="margin: 0 20px 16px 0;" @click="queryBtn">{{ $t('key1000111') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="shop_content_box">
      <div class="shop_content_item" v-for="(item, index) in shopList" :key="index">
        <div class="img_style_box">
          <!--轮播图-->
          <Carousel dots="none" @on-click="(value)=> changeCarousel(value, item)">
            <CarouselItem v-for="(ele,idx) in item.productImageList" :key="idx">
              <div class="img_style_box">
                <imageBox :src="getThumbnailImage(ele.path)" :animation="true"></imageBox>
              </div>
            </CarouselItem>
          </Carousel>
          <!--操作按钮-->
          <div class="options_box">
            <span class="opts" v-if="getPermission('ymsDistributorProductInfo_publish')" @click="publishBtn(item)">{{ $t('key1001732') }}</span>
            <span class="line_item"></span>
            <span class="opts" v-if="getPermission('ymsDistributorProductInfo_download')"
              @click="downProductData('single', item.ymsProductId)">{{ $t('key1001822') }}</span>
          </div>
        </div>
        <h2 class="list_title" :title="item.name" @click="toShopDetails(item.ymsProductId)">{{ item.name }}</h2>
        <div class="money_box" @click="toShopDetails(item.ymsProductId)">
          <div class="price">
            <!--有活动价-->
            <template v-if="item.activityPriceTalg">
              <template v-if="item.showOriginalPriceTalg">
                <span>{{ currencyState + currencySymbol(currencyState) + item.count_activityPrice }}</span>
                <span class="original_price_style">{{ currencyState + currencySymbol(currencyState) + item.count_minSuggestPrice }}</span>
              </template>
              <template v-if="item.showActivityPriceTalg">
                <span>{{ currencyState + currencySymbol(currencyState) + item.count_activityPrice }}</span>
              </template>
              <template v-if="item.showMinSuggestPriceTalg">
                <span>{{ currencyState + currencySymbol(currencyState) + item.count_minSuggestPrice }}</span>
              </template>
            </template>
            <!--无活动价-->
            <template v-else>
              <span>{{ currencyState + currencySymbol(currencyState) + item.count_minSuggestPrice }}</span>
            </template>
          </div>
        </div>
        <!--收藏图标-->
        <div class="subscribe_box" v-if="item.subscribed && getPermission('ymsDistributorMerchantSubscription_cancelSubscription')">
          <Icon size="20" color="#FF5310" type="md-heart" @click="unsubscribeBtn('single', item,index)"/>
        </div>
        <!--未收藏图标-->
        <div class="unsubscribed_box" v-if="!item.subscribed && getPermission('ymsDistributorMerchantSubscription_subscription')">
          <Icon size="20" type="md-heart-outline" @click="subscribeBtn('single', item, index)"/>
        </div>
        <!--活动标签-->
        <div class="activity_label_box" v-if="item.activityGoodsLabelList">
          <template v-for="ele in item.activityGoodsLabelList">
            <span class="activity_label_item" v-if="ele" style="background-color: #FF1810;">{{ ele }}</span>
          </template>
        </div>
      </div>
    </div>
    <img v-if="isGet" style="display: block;margin: 10px auto 0 auto;color: #FD5425" :src="loadingSvg"/>
    <!--刊登平台弹窗-->
    <publishingPlatformModal ref="publishingPlatform" @changePlatform="changePlatform"></publishingPlatformModal>
    <!--刊登店铺弹窗-->
    <selectPublishStoreModal ref="selectPublishStore"></selectPublishStoreModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import imageBox from "@/components/common/imageBox.vue";
import {amountHandel, pageJump, formatterNumber, isAlibabaDistributor, _handleMultilingualFields} from "@/utils/common";
import publishingPlatformModal from "@/components/common/publishingPlatformModal.vue";
import selectPublishStoreModal from "@/components/common/selectPublishStoreModal.vue";

export default {
  name: 'distributionMarket',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        distributorMerchantId: null, // 分销商商户号
        imageTypeList: [], // 图片类型 0:自拍模特图, 1:网红图, 2:实物摆拍图
        isInStock: 0, // 是否有货(有:1)
        maxPrice: null, // 金额上限
        minPrice: null, // 金额下限
        minInventory: null,  // 库存上限
        maxInventory: null, // 库存下限
        createdStartTime: null,
        createdEndTime: null,
        orderBy: 'overallRating', // 排序方式(可选值 综合:overallRating 总销量:totalSoldQuantity 金额:price 上新：shelvedTime 默认:overallRating )
        searchValue: '', // 全文检索关键词
        supplierMerchantId: null, // 供应商商户号
        type: null, // 类型(0 每日上新 1潮流女装 2时尚男装 3精品童装 4热销产品 5好货推荐)
        upDown: null, // down  降序  up 升序
        ymsActivityPlanId: null, // 活动流水号
        ymsProductCategoryIdList: [], // 分类流水号列表
        inventoryType: 0, // 库存类型(0 总库存 1供应商库存 2中心仓库存)
        isCollect: 2, // 是否收藏(有:1 无：0 全部：2)
        platformIdList: null, // 刊登支持平台
        ymsWarehouseIdList: [],
        productImages: [], // 上传图片搜索集合
        pageNum: 1,
        pageSize: 20
      },
      sortList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005535'), paramsKey: 'overallRating', sort: false, selected: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005536'), paramsKey: 'totalSoldQuantity', type: null, sort: true, selected: false},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'), paramsKey: 'price', sort: true, type: null, selected: false},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005537'), paramsKey: 'shelvedTime', type: null, sort: true, selected: false},
      ],
      stockTypeList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004662')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001091')},
      ],
      showDefine: true,
      shopList: [],
      isGet: false, // 是否在获取数据
      loadingSvg: require('@/assets/images/svg/loading-balls.svg'),
      hasNextPage: true,
      currentIndex: 0,
      originalPageParams: {}
    };
  },
  mounted() {
    let v = this;
    const scrollContainer = document.querySelector('.shop_content_box');
    scrollContainer.addEventListener('scroll', v.rollingLoadData);
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    isAlibabaDistributor() {
      return isAlibabaDistributor();
    },
    setCssVar() {
      return {
        '--subject-color': this.isAlibabaDistributor ? '#2D8CF0' : '#FD5425'
      };
    }
  },
  created() {
    this.originalPageParams = JSON.parse(JSON.stringify(this.pageParams));
    this.getList();
  },
  methods: {
    formatterNumber,
    // 滚动加载更多数据
    rollingLoadData() {
      let v = this;
      const imgH = 374 * 5;
      let scrollTop = document.querySelector('.shop_content_box').scrollTop || 0;
      let clientHeight = document.querySelector('.shop_content_box').clientHeight;
      let scrollHeight = document.querySelector('.shop_content_box').scrollHeight;

      if (scrollHeight - scrollTop - clientHeight < imgH) {
        if (v.hasNextPage) {
          v.getListData();
        }
      }
    },
    // 点击轮播图图片进入商品详情页
    changeCarousel(index, item) {
      this.toShopDetails(item.ymsProductId);
    },
    // 排序操作按钮
    sortBtn(idx) {
      let v = this;
      let talg = v.currentIndex === idx;
      v.pageParams.upDown = talg ? v.pageParams.upDown : 'up';
      v.sortList.map((item, index) => {
        item.selected = false;
        item.type = null;
        if (index === idx) {
          let type = null;
          item.selected = true;
          v.currentIndex = idx;
          if (item.sort) {
            if (v.pageParams.upDown == 'down') {
              type = 'up';
            } else {
              type = 'down';
            }
            item.type = type;
          }
          v.pageParams.orderBy = item.paramsKey;
          v.pageParams.upDown = item.type;
        }
      });
      v.pageParamsStatus = true;
    },
    // 升序、降序按钮
    sortupDownBtn(idx, type) {
      let v = this;
      v.sortList.map((item, index) => {
        item.selected = false;
        item.type = null;
        if (index === idx) {
          item.selected = true;
          item.type = type;
          v.pageParams.orderBy = item.paramsKey;
          v.pageParams.upDown = type;
        }
      });
      v.pageParamsStatus = true;
      v.$forceUpdate();
    },
    // 重置参数
    reset() {
      this.pageParams = JSON.parse(JSON.stringify(this.originalPageParams));
      this.sortList.map((item) => {
        item.selected = false;
        if (item.paramsKey === 'overallRating') {
          item.selected = true;
        } else {
          item.type = null;
        }
      });
      this.$forceUpdate();
      this.getList();
    },
    // 价格的确定按钮
    queryBtn() {
      this.handleFilterData('minPrice', 'maxPrice');
      this.handleFilterData('minInventory', 'maxInventory');
      this.showDefine = false;
    },
    // 处理价格、库存的筛选数据
    handleFilterData(minData, maxData) {
      let v = this;
      let min = Number(v.pageParams[minData]);
      let max = Number(v.pageParams[maxData]);

      function handleData() {
        v.pageParams[minData] = min;
        v.pageParams[maxData] = max;
        v.pageParamsStatus = true;
      }

      if (min || max) {
        if (min < max) {
          handleData();
        } else {
          handleData();
        }
        v.$forceUpdate();
      }
    },
    // 处理获取焦点
    handleFocus(data) {
      if (data) {
        this.showDefine = true;
      }
    },
    // 处理获取失去焦点
    handleBlur(data) {
      if (data) {
        this.showDefine = true;
      }
    },
    // 判断是否要显示确定查询按钮
    handleShowDefine() {
      let v = this;
      if (v.pageParams.minPrice || v.pageParams.maxPrice || v.pageParams.minInventory || v.pageParams.maxInventory) {
        return true;
      } else {
        return false;
      }
    },
    // 查询
    getList() {
      this.shopList = [];
      this.pageParams.pageNum = 1;
      this.getListData();
    },
    // 获取商品列表的数据
    getListData() {
      let v = this;
      let obj = {};
      if (v.isGet) return;
      obj.distributorMerchantId = v.userInfo.merchantId;
      v.isGet = true;
      v.hasNextPage = false;
      let params = Object.assign({}, v.pageParams, obj);
      if (v.pageParams.platformIdList) {
        let newList = [];
        if (v.pageParams.platformIdList == 'all') {
          v.platformList.map((item) => {
            newList.push(item.platformId);
          });
        } else {
          newList = [v.pageParams.platformIdList];
        }
        params.platformIdList = newList;
      }
      if (v.pageParams.ymsWarehouseIdList == 'null') {
        params.ymsWarehouseIdList = [];
      } else {
        params.ymsWarehouseIdList = v.pageParams.ymsWarehouseIdList;
      }
      let url = api.post_ymsProductInfo_shopping_query + '?fresh=KEEPNEW';
      v.axios.post(url, Object.assign({}, params, obj)).then(response => {
        v.isGet = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.list || [];
          v.shopList.push(...list);
          v.pageParams.pageNum = data.nextPage;
          v.hasNextPage = data.hasNextPage;
        }
        if (v.shopList.length > 0) {
          v.shopList.map((item) => {
            item.activityGoodsLabelList = [];
            item.activityPriceTalg = false;
            item.showOriginalPriceTalg = false;
            item.showActivityPriceTalg = false;
            item.showMinSuggestPriceTalg = false;
            if (item.activityPrice) {
              item.activityPriceTalg = true;
              item.showOriginalPriceTalg = item.minSuggestPrice > item.activityPrice;
              item.showActivityPriceTalg = item.minSuggestPrice < item.activityPrice;
              item.showMinSuggestPriceTalg = item.minSuggestPrice === item.activityPrice;
            }
            item.orgin_minSuggestPrice = item.minSuggestPrice;
            item.count_activityPrice = amountHandel(item.activityPrice);
            item.count_minSuggestPrice = amountHandel(item.minSuggestPrice);
            let activityGoodsLabels = item.activityGoodsLabels || [];
            if (activityGoodsLabels.length > 0) {
              item.activityGoodsLabelList = activityGoodsLabels.map((ele) => {
                return _handleMultilingualFields(ele);
              });
            }
          });
        }
        v.$forceUpdate();
      }).catch(() => v.isGet = false);
    },
    // 取消收藏
    unsubscribeBtn(type, data, index) {
      let v = this;
      let ymsProductIds = [];
      // 单个收藏
      if (type === 'single') {
        ymsProductIds = [data.ymsProductId];
      } else {
        v.shopList.map((item) => {
          if (item.checked) {
            ymsProductIds.push(item.ymsProductId);
          }
        });
        if (ymsProductIds.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005538'));
          return false;
        }
      }
      v.axios.post(api.post_ymsDistributorMerchantSubscription_cancelSubscription, ymsProductIds).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005539'));
          v.$set(v.shopList[index], 'subscribed', false);
          v.$forceUpdate();
          if (document.referrer) {
            window.parent.postMessage({
              type: 'subscriptionProduct',
              ymsProductId: data.ymsProductId,
              from: 'list',
              status: 0
            }, '*');
          }
        }
      });
    },
    // 收藏商品
    subscribeBtn(type, data, index) {
      let v = this;
      let ymsProductIds = [];
      // 单个收藏
      if (type === 'single') {
        ymsProductIds = [data.ymsProductId];
      } else {
        v.shopList.map((item) => {
          if (item.checked) {
            ymsProductIds.push(item.ymsProductId);
          }
        });
        if (ymsProductIds.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005540'));
          return false;
        }
      }
      v.axios.post(api.post_ymsDistributorMerchantSubscription_subscription, ymsProductIds).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005541'));
          v.$set(v.shopList[index], 'subscribed', true);
          v.$forceUpdate();
        }
      });
    },
    // 下载资料
    downProductData(type, data) {
      let v = this;
      let ymsProductIds = [];
      if (type === 'single') {
        ymsProductIds = [data];
      } else {
        v.shopList.map((item) => {
          if (item.checked) {
            ymsProductIds.push(item.ymsProductId);
          }
        });
        if (ymsProductIds.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005542'));
          return false;
        }
      }
      let query = {
        commodityPictures: ["carousel", "attribute", "sizeTable"],
        isCommodityInformation: 1,
        ymsProductIds: ymsProductIds
      };
      v.axios.post(api.post_ymsDistributorProductInfo_download, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let taskNumber = response.data.datas;
          setTimeout(() => {
            pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
          }, 30);
        }
      });
    },
    // 一键刊登
    publishBtn(data) {
      let source = data.source;
      let platformJson = data.platformJson;
      this.ymsProductId = data.ymsProductId;
      if (source === 'listing') {
        if (platformJson) {
          let obj = JSON.parse(platformJson);
          let platformIds = obj.platformIds || [];
          this.$refs['publishingPlatform'].initPublishingPlatformData(platformIds, data.ymsProductCategoryId, source);
        }
      } else {
        this.$refs['publishingPlatform'].initPublishingPlatformData(data.availablePlatforms, data.ymsProductCategoryId);
      }
    },
    // 选择刊登平台之后
    changePlatform(data) {
      let listingStatus = this.$store.state.erpConfig.merchant.listingStatus;
      let type = Number(listingStatus);
      this.$refs['selectPublishStore'].initSelectPublishStoreData(data, this.ymsProductId, type);
    },
  },
  watch: {
    // 监听参数变化更新数据
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  beforeDestroy() {
    const scrollContainer = document.querySelector('.shop_content_box');
    scrollContainer.removeEventListener('scroll', this.rollingLoadData);
  },
  components: {
    selectPublishStoreModal,
    publishingPlatformModal,
    imageBox
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.distributionMarket_box {
  width: 100%;

  .filter_box {
    margin: 20px 0 10px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .filter_box_item {
      display: flex;
      align-items: center;
      margin: 0 30px 16px 0;

      .sort_content {
        min-width: 300px;
        height: 32px;
        background: #FFFFFF;
        border: 1px solid #D7D7D7;
        border-radius: 4px;
        display: flex;
        align-items: center;

        .sort_content_item {
          display: flex;
          align-items: center;

          .sort_title {
            font-family: 'PingFangSC-Regular';
            font-size: 14px;
            color: #000;
            opacity: 0.8;
            cursor: pointer;
            padding: 0 12px;
          }

          .sort_active {
            font-weight: bold;
            color: var(--subject-color);
          }

          .sort_icon_box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-right: 4px;

            .dropup_icon {
              position: relative;
              top: 4px;
            }

            .dropdown_icon {
              position: relative;
              bottom: 4px;
            }
          }

          .line_txt {
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: #dedcdc;
          }
        }

        .sort_content_item:last-child {
          .line_txt {
            display: none;
          }
        }
      }

      .line_item {
        display: inline-block;
        margin: 0 4px;
        font-weight: bold;
      }

      .price_input {
        width: 150px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
      }

      .stock_select {
        width: 110px;

        /deep/ .ivu-select-selection {
          height: 30px;
          border: none !important;
          box-shadow: initial !important;
          border-radius: initial !important;
          border-right: 1px solid #dcdee2 !important;
        }
      }

      .stock_input_box {
        display: flex;
        align-items: center;

        .stock_input {
          width: 150px;
          height: 30px;
          border: none !important;
          box-shadow: initial !important;
          border-radius: initial !important;

          /deep/ .ivu-input-number-handler-wrap {
            display: none;
          }

          /deep/ .ivu-input-number-input {
            text-align: center;
          }
        }
      }
    }

    .stock_styles {
      border-radius: 4px;
      border: 1px solid #dcdee2;
      background-color: #fff;
      box-sizing: border-box;
      overflow: hidden;
    }
  }

  .shop_content_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    max-height: 750px;
    overflow-y: auto;

    .shop_content_item {
      width: 250px;
      height: 320px;
      border-radius: 4px;
      margin: 0 0 20px 18px;
      background-color: #fff;
      position: relative;

      .img_style_box {
        width: auto;
        max-width: 250px;
        height: 250px;
        overflow: hidden;
        position: relative;
      }

      /deep/ .ivu-carousel {
        width: 100%;
        height: 100%;
        cursor: pointer;

        .ivu-carousel-arrow {
          width: 24px;
          height: 32px;
          background: #000000;
          opacity: 0.4;
          display: none;
          justify-content: center;
          align-items: center;

          .ivu-icon {
            font-size: 22px;
            color: #fff;
          }
        }

        .ivu-carousel-arrow.right {
          right: 0;
          border-radius: 4px 0px 0px 4px;
        }

        .ivu-carousel-arrow.left {
          border-radius: 0px 4px 4px 0px;
          left: 0;
        }

        &:hover {
          .ivu-carousel-arrow {
            display: flex;
          }
        }
      }

      .options_box {
        display: flex;
        align-items: center;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: -32px;
        z-index: 200;
        background-color: rgba(255, 255, 255, 0.8);
        transition: all .3s ease-in;

        .opts {
          display: inline-block;
          width: 124.5px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #000;
          font-family: 'PingFangSC-Regular';
          cursor: pointer;

          &:hover {
            color: #fff;
            background-color: var(--subject-color);
          }
        }

        .line_item {
          display: inline-block;
          width: 1px;
          height: 32px;
          background: #d9d9d9;
        }
      }

      .list_title {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #000;
        font-size: 14px;
        font-family: 'PingFangSC-Regular';
        padding: 0 8px;
        margin: 6px 0 8px 0;
        cursor: pointer;

        &:hover {
          color: var(--subject-color);
          text-decoration: underline;
        }
      }

      .money_box {
        .price {
          font-family: 'PingFangSC-Semibold';
          padding: 0 8px;
          font-size: 14px;
          font-weight: 600;
          color: #000;
          cursor: pointer;
        }

        .original_price_style {
          color: #8D8D8D;
          text-decoration: line-through;
          padding-left: 5px;
          font-weight: normal;
        }
      }

      .subscribe_box, .unsubscribed_box {
        position: absolute;
        background-color: #fff;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        top: 8px;
        right: 8px;
        z-index: 100;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2000);
        cursor: pointer;
      }

      .unsubscribed_box {
        display: none;
      }

      .activity_label_box {
        position: absolute;
        top: 0px;
        left: 0;
        display: flex;
        flex-direction: column;
        z-index: 100;

        .activity_label_item {
          color: #fff;
          font-size: 12px;
          border-bottom-right-radius: 15px;
          padding: 2px 8px;
          display: inline-block;
          margin-bottom: 8px;
        }
      }

      &:hover {
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);

        .options_box {
          bottom: 0;
        }

        .unsubscribed_box {
          display: flex;
        }
      }
    }
  }
}
</style>
